<section class="layout-pt-md layout-pb-md bg-dark-2" style="background-color: #0D2857 !important;">
  <div class="container">
    <div class="row y-gap-30 justify-between items-center">
      <div class="col-auto">
        <div class="row y-gap-20 flex-wrap items-center">
          <div class="col-auto">
            <div class="icon-newsletter text-60 sm:text-40" style="color: white;"></div>
          </div>
          <div class="col-auto">
            <h4 class="text-26 fw-600" style="color: white !important;">Seyahat Yolculuğunuz Burada Başlıyor</h4>
            <div style="color: white !important;">Kayıt olun, en iyi fırsatları size gönderelim</div>
          </div>
        </div>
      </div>

      <div class="col-auto">
        <div class="single-field -w-410 d-flex x-gap-10 y-gap-20">
          <div>
            <input 
              class="bg-white h-60" 
              type="email" 
              placeholder="E-posta adresiniz"
              [(ngModel)]="email">
          </div>
          <div>
            <button 
              class="button -md h-60 bg-blue-1 text-white"
              (click)="subscribe()">
              Abone Ol
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
